import React from "react";
import styles from "../../styles/Navigation.module.css";
import StageSelector from "./StageSelector";
import QuestionGrid from "./QuestionGrid";
import NavArrows from "./NavArrows";
import { useNavigation } from "../../hooks/useNavigation";

export default function NavigationBar(props) {
  const {
    activeQuestion,
    stage,
    section,
    questionCount,
    stageCompletionStatus,
    handlePrevQuestion,
    handleNextQuestion,
    handleStage,
    handleQuestion,
    isAnswered,
    sectionUnitLabel,
  } = useNavigation(props);

  return (
    <footer className={`${styles.footer} footer `}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          width: "100%",
        }}
      >
        {props.section !== "writing" && (
          <StageSelector
            section={section}
            stage={stage}
            sectionUnitLabel={sectionUnitLabel}
            handleStage={handleStage}
            stageCompletionStatus={stageCompletionStatus}
          />
        )}
        <QuestionGrid
          questionCount={questionCount}
          handleQuestion={handleQuestion}
          activeQuestion={activeQuestion}
          isAnswered={isAnswered}
          section={section}
          stage={stage}
          handleStage={handleStage}
        />
        <NavArrows
          stage={stage}
          activeQuestion={activeQuestion}
          questionCount={questionCount}
          handlePrevQuestion={handlePrevQuestion}
          handleNextQuestion={handleNextQuestion}
        />
      </div>
    </footer>
  );
}
